import Icon from '../icon';
import Nav from '../nav';
import {Service, ServiceData} from './service';

export default class ServicesPanel {
	private readonly header: HTMLElement = document.querySelector('#outer-container > header') as HTMLElement;
	private readonly container: HTMLDivElement = document.createElement('div');
	private readonly panel: HTMLDivElement = document.createElement('div');
	private readonly nav: HTMLElement = document.createElement('nav');
	private readonly allButton: HTMLAnchorElement = document.createElement('a');
	private readonly triggers: HTMLAnchorElement[] = [];
	private hasLoaded: boolean = false;
	private _isOpen: boolean = false;
	private services?: Service[];

	public readonly navList: HTMLUListElement = document.createElement('ul');
	public readonly details: HTMLDivElement = document.createElement('div');

	constructor(private readonly mainNavigation: Nav) {
		this.container.id = 'services-panel-container';
		this.panel.id = 'services-panel';
		this.container.append(this.panel);
		this.panel.append(this.nav, this.details);
		this.nav.append(this.navList);
		this.mainNavigation.shade.addEventListener('click', () => this.toggle(false));
		this.allButton.append(_t('allServices') + ' ', Icon.create('long-arrow-right'));
		this.allButton.className = 'btn';
		this.load();
		window.addEventListener('resize', () => this.load());
	}

	private attach(): void {
		document.querySelectorAll<HTMLLIElement>('li.services-panel-trigger').forEach((item) => {
			const a = item.querySelector('a');
			if (!a) return;
			a.addEventListener('click', (event) => {
				if (window.innerWidth < this.mainNavigation.breakpoint) return;
				event.preventDefault();
				this.toggle();
				return false;
			});
			this.triggers.push(a);
			if (!this.allButton.href) this.allButton.href = a.href;
		});
	}

	private async load(): Promise<void> {
		if (window.innerWidth < this.mainNavigation.breakpoint) return this.toggle(false);
		if (this.hasLoaded) return;
		this.hasLoaded = true;
		const response = await fetch('/feeds/services');
		const servicesData: ServiceData[] = await response.json();
		const allButtonItem = document.createElement('li');
		this.services = servicesData.map((service) => new Service(this, service));
		this.activateService(this.services[0]);
		this.header.append(this.container);
		this.navList.append(allButtonItem);
		allButtonItem.append(this.allButton);
		this.attach();
		for await (const service of this.services) await service.loadImage();
	}

	public activateService(serviceToActivate: Service): void {
		if (!this.services) return;
		for (const service of this.services) {
			service.isActive = service === serviceToActivate;
		}
	}

	public toggle(open?: boolean): void {
		this.isOpen = open === undefined ? !this.isOpen : open;
	}

	public set isOpen(isOpen: boolean) {
		this._isOpen = isOpen;
		document.body.classList.toggle('services-panel-open', this.isOpen);
	}

	public get isOpen(): boolean {
		return this._isOpen;
	}
}
